/** @jsx h */

import { styleguide } from 'styleguide'
import styled, { css } from 'preact-emotion'
import { springIn60, springIn40, springY } from './utils'
const shadowIndex = 0

const corners = direction => css`
  border-${direction}-left-radius: ${styleguide.radii.outer};
  border-${direction}-right-radius: ${styleguide.radii.outer};
  ${direction}: 0;
`
export const Background = styled('div')`
  width: 100%;
  height: 0.9rem;
  position: absolute;
  left: 0;
  z-index: 1;
  transition: transform 300ms ${styleguide.timingFuncs.ease},
    box-shadow 300ms ${styleguide.timingFuncs.ease};
  background-color: ${styleguide.colors.background};
  ${props => corners(props.position)};
  ${props => props.rendered && `animation: ${springIn60} 1s linear 1;`};
  ${props => (props.springToY ? springY(props.springToY, 'soft') : null)};
`

export const Wrapper = styled('div')`
  position: absolute;
  font-family: ${props => (props.textFont ? props.textFont : 'inherit')};
  font-weight: ${props => (props.textWeight ? props.textWeight : 'inherit')};
  transform: 0;
  transition: opacity 300ms ${styleguide.timingFuncs.ease},
    transform 300ms ${styleguide.timingFuncs.ease};
  opacity: 0;
  animation-fill-mode: both;
  pointer-events: none;
  &.in {
    opacity: 1;
    animation: ${springIn60} 1s linear 1;
  }
  &.out {
    opacity: 0;
  }
  ${props => (props.springToY ? springY(props.springToY, 'soft') : null)};
`

export const Outer = styled('div')`
  padding: ${styleguide.spacing.l};
  position: relative;
  border-radius: ${styleguide.radii.outer};
  transition: all 300ms ${styleguide.timingFuncs.ease};
  z-index: 3;

  &:after {
    content: '';
    transition: height 300ms ${styleguide.timingFuncs.ease},
      box-shadow 300ms ${styleguide.timingFuncs.ease},
      transform 300ms ${styleguide.timingFuncs.ease};
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    z-index: ${shadowIndex};
    height: ${props => props.height}px;
    box-shadow: 0px 25px 25px 1px rgba(0, 0, 0, 0.25);
    border-radius: ${styleguide.radii.outer};
    transform: ${props => `translateY(${props.shadowOffset}px)`};
  }
`

export const Container = styled('div')`
  transition: transform 300ms ${styleguide.timingFuncs.ease};
  position: relative;
  &:hover {
    transform: translate3d(0, -4px, 0);
    ${Outer}:after {
      box-shadow: 0px 25px 25px 1px rgba(0, 0, 0, 0.4);
    }
  }
`

export const Inner = styled('div')`
  opacity: 0;
  position: relative;
  z-index: ${shadowIndex + 1};
  transition: opacity 300ms ${styleguide.timingFuncs.ease};
  &.in {
    opacity: 1;
    animation: ${springIn40} 1s linear 1;
    transition-delay: 120ms;
    animation-delay: 120ms;
  }
`

export const Divider = styled('hr')`
  border: 0;
  margin: ${styleguide.spacing.m} 0 0;
  border-bottom: 1px solid ${styleguide.colors.lightGray};
`



// WEBPACK FOOTER //
// ../api/src/components.jsx